<template>
  <div class="withholdingList">
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
      @searchCompanyName="searchCompanyName"
    ></SiruiSearch>
    <!--内容区域-->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="false"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        @chooseClick="chooseClick"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
        @dblclickEvent="dblclickEvent"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :visible="item.visible"
          :width="item.width || 120"
          :sortable="item.sortable"
          :formatter="item.formatter"
          :field="item.field"
          :type="item.type"
          :params="item.params"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.dictType">
              {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
            </span>
            <span v-else-if="item.format">
              {{ scope.row[item.field] | formatTableColumn(item.format) }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <!--批量确认 -->
    <BatchConfirmDialog ref="batchConfirmDialog" />
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import API from '@/api/financeCenter/withholding';
  import DataBaseAPI from '@/api/dataBase';
  // import AGENCY_API from '@/api/agencyContract/index';
  import { filterEmpty } from '@/common/js/util';
  // import MASTER_API from '@/api/masterData/company.js';
  import tableMixins from '@/common/mixins/table.js';
  // import qs from 'qs';
  // import siruiUpload from '@/components/SiruiUpload';
  // import loading from '@/common/js/load.js'; //loading
  // import InputNumber from '@/components/form-item/input-number';
  import BatchConfirmDialog from '@/components/Dialog/batchConfirmDialog';
  import XEUtils from 'xe-utils';
  export default {
    name: 'withholdingList',
    mixins: [tableMixins],
    components: {
      // siruiUpload,
      // InputNumber,
      BatchConfirmDialog,
    },
    data() {
      return {
        query: {
          startRequestAmount: undefined,
          endRequestAmount: undefined,
          accruedCompanyCode: undefined,
          accruedDepartmentCode: undefined,
          voucherNo: null,
        },
        companyList: [], //公司列表
        departmentList: [], //部门列表
        //表格显示字段
        columnListDefault: [
          { type: 'checkbox', visible: true, width: '50', fixed: 'left' },
          {
            field: 'accruedCompanyName',
            title: 'withholdingList.column.accruedCompanyName',
            visible: true,
            width: 120,
          }, //公司名称
          {
            field: 'accruedDepartmentName',
            title: 'withholdingList.column.accruedDepartmentName',
            visible: true,
            width: 120,
          }, //部门名称
          { field: 'docNo', title: 'withholdingList.column.docNo', visible: true, width: 150 }, //单据编号
          {
            field: 'contractNo',
            title: 'withholdingList.column.contractNo',
            visible: true,
            width: 120,
          }, //采购/销售合同号
          {
            field: 'supplierName',
            title: 'withholdingList.column.supplierName',
            visible: true,
            width: 120,
          }, //供应商名称
          {
            field: 'accruedType',
            title: 'withholdingList.column.accruedType',
            visible: true,
            dictType: 'accrued_Type',
            width: 120,
          }, //预提类型
          { field: 'docDate', title: 'withholdingList.column.docDate', visible: true, width: 120 }, //制单日期
          {
            field: 'accountedDate',
            title: 'withholdingList.column.accountedDate',
            visible: true,
            width: 120,
          }, //入账日期
          {
            field: 'docStatus',
            title: 'withholdingList.column.docStatus',
            visible: true,
            width: 120,
            dictType: 'accrued_status',
          }, //单据状态
          {
            field: 'accountingStatus',
            title: 'withholdingList.column.accountingStatus',
            visible: true,
            width: 120,
            dictType: 'post_status',
          }, //入账状态
          { field: 'voucherNo', title: '凭证号', visible: true },
          {
            field: 'inboundNo',
            title: 'withholdingList.column.inboundNoLadingNo',
            visible: true,
            width: 120,
          }, //业务入库单号/销售提单号
          {
            field: 'businessInboundBatchNo',
            title: 'withholdingList.column.businessInboundBatchNoLading',
            visible: true,
            width: 120,
          }, //业务入库批次号/提单行号
          {
            field: 'inboundQuantity',
            title: 'withholdingList.column.inboundQuantity',
            visible: true,
            width: 120,
          }, //业务入库数/提单实发数量
          {
            field: 'accruedAmount',
            title: 'withholdingList.column.accruedAmount',
            format: 'formatAmountRound',
            visible: true,
            width: 100,
          }, //预提金额原币
          {
            field: 'companyAccruedAmount',
            title: 'withholdingList.column.companyAccruedAmount',
            format: 'formatAmountRound',
            visible: true,
            width: 100,
          }, //预提金额本币
          // { field: "priceWithTax",title: "withholdingList.column.priceWithTax",format: "formatAmountRound",visible: true,width:100,},//业务结算单价
          // { field: "pricewithoutTax",title: "withholdingList.column.pricewithoutTax",format: "formatAmountRound",visible: true,width:100,},//不含税单价
          // { field: "purePrice",title: "withholdingList.column.purePrice",format: "formatAmountRound",visible: true,width:120,},//业务结算价净值
          // { field: "amountWithTax",title: "withholdingList.column.amountWithTax",format: "formatAmountRound",visible: true,width:120,},//业务结算价含税金额
          // { field: "taxAmount",title: "withholdingList.column.taxAmount",format: "formatAmountRound",visible: true,width:120,},//业务结算价税额
          // { field: "taxRate",title: "withholdingList.column.taxRate",visible: true,width:120,},//税率
          {
            field: 'storageName',
            title: 'withholdingList.column.storageName',
            visible: true,
            width: 120,
          }, //仓库名称
          {
            field: 'productDesc',
            title: 'withholdingList.column.productDesc',
            visible: true,
            width: 120,
          }, //物料描述
        ],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        dictList: (state) => state.dict.dictList,
        tokenInfo() {
          return {
            access_token: this.userInfo.access_token,
            companyCode: this.userInfo.companyCode,
            companyName: this.userInfo.companyName,
            departmentCode: this.userInfo.departmentCode,
            departmentName: this.userInfo.departmentName,
            tenantCode: this.userInfo.tenantCode,
          };
        },
      }),
      //搜索字段
      searchColumns() {
        return [
          {
            //公司代码
            prop: 'accruedCompanyCode',
            name: this.$t('withholdingList.column.accruedCompanyName'),
            type: 'select',
            placeholder: this.$t('withholdingList.placeholder.accruedCompanyCodePlaceholder'),
            options: this.companyList,
            relatedColumn: 'none',
            changeMethod: 'searchCompanyName',
          },
          {
            //部门
            prop: 'accruedDepartmentCode',
            name: this.$t('withholdingList.column.accruedDepartmentName'),
            placeholder: this.$t('withholdingList.placeholder.accruedDepartmentCodePlaceholder'),
            type: 'select',
            relatedColumn: 'none',
            options: this.departmentList,
          },
          //物料描述
          {
            prop: 'productDesc',
            name: this.$t('withholdingList.column.productDesc'),
            type: 'input',
            placeholder: this.$t('withholdingList.placeholder.productDescPlaceholder'),
          },
          //仓库
          {
            prop: 'storageName',
            type: 'searchTableSpec',
            name: this.$t('withholdingList.column.storageName'),
            placeholder: this.$t('withholdingList.placeholder.storageNamePlaceholder'),
            searchType: 'warehouse',
            isMultiple: true,
          },
          //供应商
          {
            prop: 'supplierName',
            name: this.$t('withholdingList.column.supplier'),
            type: 'searchTableSpec',
            searchType: 'supplier',
            placeholder: this.$t('withholdingList.placeholder.supplierPlaceholder'),
            extraData: {
              departmentCode: this.query.accruedDepartmentCode, //部门
              companyCode: this.query.accruedCompanyCode, //公司
            },
            isMultiple: true,
          },
          //采购合同号
          {
            prop: 'contractNo',
            name: this.$t('withholdingList.column.contractNo'),
            type: 'input',
            placeholder: this.$t('withholdingList.placeholder.contractNoPlaceholder'),
          },
          {
            //费用/预提类型
            prop: 'accruedType',
            type: 'dictSelect',
            name: this.$t('withholdingList.column.accruedType'),
            apiData: { dictType: 'accrued_Type' },
            placeholder: this.$t('withholdingList.placeholder.accruedTypePlaceholder'),
            clearable: true,
          },
          {
            //单据状态
            prop: 'docStatus',
            type: 'dictSelect',
            name: this.$t('withholdingList.column.docStatus'),
            apiData: { dictType: 'accrued_status' },
            placeholder: this.$t('withholdingList.placeholder.docStatusPlaceholder'),
            clearable: true,
          },
          //业务入库批次号
          {
            prop: 'businessInboundBatchNo',
            name: this.$t('withholdingList.column.businessInboundBatchNoLading'),
            type: 'input',
            placeholder: this.$t('withholdingList.placeholder.businessInboundBatchNoPlaceholder'),
          },

          //单据编号
          {
            prop: 'docNo',
            type: 'input',
            name: this.$t('withholdingList.column.docNo'),
            placeholder: this.$t('withholdingList.placeholder.docNoPlaceholder'),
          },
          // 入账日期
          {
            prop: 'startAccountedDate',
            name: this.$t('withholdingList.column.startAccountedDate'),
            type: 'startDaterangePicker',
            placeholder: this.$t('withholdingList.placeholder.startAccountedDatePlaceholder'),
          },
          {
            prop: 'endAccountedDate',
            name: this.$t('withholdingList.column.endAccountedDate'),
            type: 'endDaterangePicker',
            placeholder: this.$t('withholdingList.placeholder.endAccountedDatePlaceholder'),
          },
          //入账状态
          {
            prop: 'accountingStatus',
            name: this.$t('withholdingList.column.accountingStatus'),
            type: 'dict',
            dictType: 'post_status',
            placeholder: this.$t('withholdingList.placeholder.accountingStatusPlaceholder'),
            clearable: true,
          },
          {
            prop: 'voucherNo',
            name: '凭证号',
            type: 'input',
            placeholder: this.$t('请输入凭证号'),
          },
        ];
      },
    },
    /**页面必要代码Start */
    mounted() {
      this.getData();
      this.getButtonList();
      this.getCompany();
    },
    methods: {
      getDictValue({ cellValue, column }) {
        return this.$baseRequest.getDictValueByType(column.params.name, cellValue);
      },
      //获取公司信息
      async getCompany() {
        const selectStatus = await this.$axios.get(
          `${DataBaseAPI.LISTDATA_SERECHCOMPANY}/${this.userInfo.tenantCode}`
        );
        if (selectStatus.data.code == 0) {
          this.companyList = selectStatus.data.data;
        }
      },
      //获取数据
      getData() {
        this.loading.startLoading();
        let query = this.setSearchParams();
        this.$axios.post(API.ACCRUED_LIST, filterEmpty(query)).then((res) => {
          this.loading.endLoading();
          if (0 == res.data.code) {
            this.tableData = res.data.data.records || [];
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // 查询参数整理
      setSearchParams() {
        // 分页数据
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        const query = this.query;
        const result = Object.assign({}, query, {
          pageNum,
          pageSize,
          storageNo:
            query.storageName && query.storageName[0] ? query.storageName[0].storageCode : '',
          storageName:
            query.storageName && query.storageName[0] ? query.storageName[0].storageName : '',
          supplierName:
            query.supplierName && query.supplierName[0] ? query.supplierName[0].partnerZhName : '',
          supplierNo:
            query.supplierName && query.supplierName[0] ? query.supplierName[0].partnerCode : '',
        });
        return filterEmpty(result);
      },
      // 选择公司
      searchCompanyName(val) {
        this.departmentList = [];
        this.query.accruedDepartmentCode = '';
        this.getdepartmentList(val.val);
      },
      // 根据公司查询部门
      getdepartmentList(companyCode) {
        this.$axios.post(DataBaseAPI.LIST_DEPARTMENT_API + '/' + companyCode).then((res) => {
          if (res.data.code === 0) {
            this.departmentList = res.data.data;
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },
      //点击按钮触发的方法
      chooseClick(type) {
        if (type == 'add') {
          this.add();
        } else if (type == 'edit') {
          if (this.multipleSelection.length !== 1) {
            this.$message({
              showClose: true,
              message: '请选择一条数据修改',
              type: 'error',
            });
          } else {
            const item = this.multipleSelection[0];
            if (['Saved', 'Rejected'].indexOf(item.docStatus) != -1) {
              let path = {
                path: '/withholding/withholdingEdit',
                name: 'withholdingEdit',
                meta: {
                  keepAlive: true,
                  title: '预提单编辑',
                },
                query: { id: item.id, isEdit: 'Y' },
              };
              this.$store.dispatch('tagsView/addTabView', path).then(() => {
                this.$nextTick(() => {
                  this.$router.push(path);
                });
              });
            } else {
              this.$message({
                showClose: true,
                message: '当前数据无法修改',
                type: 'error',
              });
            }
          }
        } else if (type == 'copy') {
          if (this.multipleSelection.length !== 1) {
            this.$message({
              showClose: true,
              message: '请选择一条数据复制',
              type: 'error',
            });
          } else {
            const item = this.multipleSelection[0];
            let path = {
              path: '/withholding/withholdingAdd',
              name: 'withholdingAdd',
              meta: {
                keepAlive: true,
                title: '预提单新建',
              },
              query: { id: item.id, isEdit: 'Y', copy: true },
            };
            this.$store.dispatch('tagsView/addTabView', path).then(() => {
              this.$nextTick(() => {
                this.$router.push(path);
              });
            });
          }
        } else if (type == 'delete') {
          this.delete();
        } else if (type == 'export') {
          this.export();
        } else if (type == 'batchSyncVoucher') {
          this.batchSyncVoucher(API.ACCRUED_BATCHSYNCVOUCHER, {
            idList: this.multipleSelection.map((it) => it.id),
          });
        } else if (type == 'batchSignSyncVoucher') {
          this.batchSyncVoucher(API.ACCRUED_SIGN_BATCHSYNCVOUCHER, {
            idList: this.multipleSelection.map((it) => it.id),
          });
          // ============ liuhongxia  批量生成凭证 ============
        } else if (type === 'doBatchConfirm') {
          this.doBatchConfirm('AE_AP_ACCRUED', {
            idList: this.multipleSelection.map((it) => it.id),
          });
        } else {
          this.$message({
            showClose: true,
            message: this.$t('error.clickError'),
            type: 'error',
          });
        }
      },
      //新增
      add() {
        let path = {
          path: '/withholding/withholdingAdd',
          name: 'withholdingAdd',
          meta: {
            keepAlive: true,
            title: '预提单创建',
          },
          query: { isEdit: 'Y' },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      // 删除
      delete() {
        if (this.multipleSelection.length == 0) {
          this.$message({
            showClose: true,
            message: '请选择需要删除的数据',
            type: 'error',
          });
          return false;
        } else {
          let canDelitems = [];
          for (let i = 0; i < this.multipleSelection.length; i++) {
            let temp = this.multipleSelection[i];
            if (temp.docStatus != 'Saved' && temp.docStatus != 'Rejected') {
              this.$message({
                showClose: true,
                message: '只能选择保存或者退回状态的记录！',
                type: 'error',
              });
              return false;
            } else {
              canDelitems.push(temp['id']);
            }
          }
          this.$confirmAction()
            .then(() => {
              this.$axios.post(API.ACCRUED_DELETE, canDelitems).then((res) => {
                if (0 == res.data.code) {
                  this.$message({ showClose: true, message: res.data.msg, type: 'success' });
                  this.resetBtnClick();
                } else {
                  this.$alert(res.data.msg);
                }
              });
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: this.$t('confirm.deleteCancelled'),
              });
            });
        }
      },
      // 跳转详情页
      dblclickEvent(e) {
        let path = {
          path: '/withholding/withholdingEdit',
          name: 'withholdingEdit',
          meta: {
            keepAlive: true,
            title: '预提单详情',
          },
          query: { id: e.row.id, isEdit: 'N' },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      // 导出
      export() {
        const selectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
        let changeList = this.multipleSelection.concat(selectedList);
        if (changeList.length > 0) {
          let str = '';
          // let ids = changeList.forEach((item) => {
          //   str += 'ids=' + item.id + '&';
          // });
          window.location.href = `${this.baseUrl}${API.ACCRUED_EXPORTS}?${str}access_token=${this.userInfo.access_token}`;
        } else {
          let params = this.query;
          delete params.pageNum;
          delete params.pageSize;
          params = XEUtils.serialize(params);
          var reg = new RegExp('%5B%5D', 'g');
          params = params.replace(reg, '');
          window.location.href = `${this.baseUrl}${API.ACCRUED_EXPORTS}?${params}&access_token=${this.userInfo.access_token}`;
        }
      },
    },
  };
</script>
